import React from 'react';
import { MapPin, Award, Thermometer, ShieldCheck } from 'lucide-react';
const pillars = [{
  icon: MapPin,
  label: 'Origen Controlado',
  description: 'Ganado seleccionado de los mejores pastizales de la sierra ecuatoriana. Trazabilidad completa desde el campo.'
}, {
  icon: Award,
  label: 'Calidad Certificada',
  description: 'Procesos certificados AGROCALIDAD y BPM que garantizan inocuidad y calidad premium en cada corte.'
}, {
  icon: Thermometer,
  label: 'Cadena de Frío',
  description: 'Temperatura ideal mantenida desde el corte hasta tu puerta. Sin interrupciones, sin compromisos.'
}, {
  icon: ShieldCheck,
  label: 'Maduración 21 Días',
  description: 'Cortes madurados en cámara controlada por 21 días para máxima terneza, sabor y experiencia.'
}];
export function KnowYourCut() {
  return <section id="calidad" className="bg-surface py-16 md:py-24 px-4 md:px-8" data-id="element-123">
      <div className="max-w-7xl mx-auto" data-id="element-124">
        <div className="text-center mb-12 md:mb-16" data-id="element-125">
          <p className="text-[9px] uppercase tracking-[0.3em] text-fire font-semibold mb-4" data-id="element-126">
            — Transparencia total
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-ink leading-tight" data-id="element-127">
            Conoce <em className="text-fire not-italic italic" data-id="element-128">Tu Corte</em>
          </h2>
        </div>

        {/* Pillars */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-px bg-ink/5 mb-16" data-id="element-129">
          {pillars.map(pillar => <div key={pillar.label} className="bg-surface p-6 md:p-8 flex flex-col items-center text-center border-t-2 border-fire/40" data-id="element-130">
              <div className="mb-4 text-fire" data-id="element-131">
                <pillar.icon className="w-5 h-5" strokeWidth={1.5} data-id="element-132" />
              </div>
              <h3 className="text-[10px] uppercase tracking-[0.18em] font-semibold text-ink mb-3" data-id="element-133">
                {pillar.label}
              </h3>
              <p className="text-muted text-xs font-light leading-relaxed" data-id="element-134">
                {pillar.description}
              </p>
            </div>)}
        </div>

        {/* Split: Quote + Image */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-ink/5" data-id="element-135">
          <div className="bg-surface p-8 md:p-14 flex flex-col justify-center" data-id="element-136">
            <p className="text-[9px] uppercase tracking-[0.2em] text-fire font-semibold mb-6" data-id="element-137">
              — Nuestra Garantía
            </p>
            <blockquote className="text-2xl md:text-3xl font-heading italic text-ink leading-snug mb-6" data-id="element-138">
              "Si no es el mejor corte que has probado, te devolvemos tu
              dinero."
            </blockquote>
            <div className="flex items-center gap-3" data-id="element-139">
              <div className="w-6 h-px bg-fire" data-id="element-140" />
              <span className="text-[10px] uppercase tracking-[0.18em] text-muted" data-id="element-141">
                Equipo Corte Quiteño
              </span>
            </div>
          </div>
          <div className="relative h-64 md:h-auto overflow-hidden" data-id="element-142">
            <img src="https://images.unsplash.com/photo-1551135049-8a33b5883817?auto=format&fit=crop&q=80&w=1000" alt="Corte de carne cruda premium" className="w-full h-full object-cover" data-id="element-143" />
            <div className="absolute inset-0 bg-gradient-to-r from-surface/30 to-transparent" data-id="element-144" />
          </div>
        </div>
      </div>
    </section>;
}